// 챗 시간 컴포넌트
const ChatTimestamp = ({ time, isUser }) => (
  <p
    className={`text-sm text-neutral-600 ${
      !isUser ? "px-10" : "px-8 text-right"
    }`}
  >
    {time}
  </p>
);

export default ChatTimestamp;
